export default __webpack_public_path__ + "static/media/payment-successfull.f1d058d8.svg";